import { css } from '@styled-system/css';
import { container, stack } from '@styled-system/patterns';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className={container({ maxW: 'lg', py: 'xl' })}>
      <div className={stack({ gap: 'lg', align: 'center', textAlign: 'center' })}>
        <h1
          className={css({
            fontSize: '6xl',
            fontWeight: 'bold',
            color: 'primary.600',
          })}
        >
          404
        </h1>

        <div className={stack({ gap: 'sm', align: 'center' })}>
          <h2
            className={css({
              fontSize: '2xl',
              fontWeight: 'bold',
              color: 'gray.900',
              _dark: { color: 'gray.100' },
            })}
          >
            {t('notFound.title')}
          </h2>

          <p
            className={css({
              fontSize: 'base',
              color: 'gray.600',
              _dark: { color: 'gray.400' },
            })}
          >
            {t('notFound.description')}
          </p>
        </div>

        <Link
          to="/"
          className={css({
            bg: 'primary.600',
            color: 'white',
            px: 'lg',
            py: 'sm',
            rounded: 'md',
            fontSize: 'base',
            fontWeight: 'medium',
            textDecoration: 'none',
            _hover: {
              bg: 'primary.700',
            },
            transition: 'colors',
          })}
        >
          {t('notFound.backHome')}
        </Link>
      </div>
    </div>
  );
}
